export default __webpack_public_path__ + "static/media/bank.b826e800.svg";